import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-95276450"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "detail"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "content-title"
}, "充值记录详情", -1));
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "cell-item"
}, "收款机构", -1));
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "cell-item"
}, "用户", -1));
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "cell-item"
}, "交易方向", -1));
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "cell-item"
}, "缴费方式", -1));
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "cell-item"
}, "实际支付金额", -1));
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "cell-item"
}, "交易时间", -1));
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "cell-item"
}, "交易类型", -1));
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "cell-item"
}, "优惠价抵扣金额", -1));
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "cell-item"
}, "流水总金额", -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_descriptions_item = _resolveComponent("el-descriptions-item");
  const _component_el_descriptions = _resolveComponent("el-descriptions");
  const _directive_loading = _resolveDirective("loading");
  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createVNode(_component_el_descriptions, {
    column: 2,
    border: ""
  }, {
    default: _withCtx(() => [_createVNode(_component_el_descriptions_item, null, {
      label: _withCtx(() => [_hoisted_3]),
      default: _withCtx(() => [_createTextVNode(" " + _toDisplayString($data.transactionFlow.orgName), 1)]),
      _: 1
    }), _createVNode(_component_el_descriptions_item, null, {
      label: _withCtx(() => [_hoisted_4]),
      default: _withCtx(() => [_createTextVNode(" " + _toDisplayString($data.transactionFlow.customerName), 1)]),
      _: 1
    }), _createVNode(_component_el_descriptions_item, null, {
      label: _withCtx(() => [_hoisted_5]),
      default: _withCtx(() => [_createTextVNode(" " + _toDisplayString($data.transactionFlow.orient), 1)]),
      _: 1
    }), _createVNode(_component_el_descriptions_item, null, {
      label: _withCtx(() => [_hoisted_6]),
      default: _withCtx(() => [_createTextVNode(" " + _toDisplayString($data.transactionFlow.payWay), 1)]),
      _: 1
    }), _createVNode(_component_el_descriptions_item, null, {
      label: _withCtx(() => [_hoisted_7]),
      default: _withCtx(() => [_createTextVNode(" " + _toDisplayString($data.transactionFlow.payFee), 1)]),
      _: 1
    }), _createVNode(_component_el_descriptions_item, null, {
      label: _withCtx(() => [_hoisted_8]),
      default: _withCtx(() => [_createTextVNode(" " + _toDisplayString($data.transactionFlow.tradeTime), 1)]),
      _: 1
    }), _createVNode(_component_el_descriptions_item, null, {
      label: _withCtx(() => [_hoisted_9]),
      default: _withCtx(() => [_createTextVNode(" " + _toDisplayString($data.transactionFlow.tradeType), 1)]),
      _: 1
    }), _createVNode(_component_el_descriptions_item, {
      span: 3
    }, {
      label: _withCtx(() => [_hoisted_10]),
      default: _withCtx(() => [_createTextVNode(" " + _toDisplayString($data.transactionFlow.couponFee), 1)]),
      _: 1
    }), _createVNode(_component_el_descriptions_item, null, {
      label: _withCtx(() => [_hoisted_11]),
      default: _withCtx(() => [_createTextVNode(" " + _toDisplayString($data.transactionFlow.totalFee), 1)]),
      _: 1
    })]),
    _: 1
  })])), [[_directive_loading, $data.loading]]);
}